/**
 * Pop-up Module JavaScript
 * Handles display logic, triggers, and cookie management
 */

(function($) {
    'use strict';

    class DTPopup {
        constructor() {
            this.modalInstances = {};
            this.init();
        }

        init() {
            // Wait for DOM to be ready
            $(document).ready(() => {
                this.initPopups();
            });
        }

        initPopups() {
            const popups = document.querySelectorAll('.dt-popup');

            popups.forEach(popup => {
                const popupId = popup.dataset.popupId;
                const trigger = popup.dataset.popupTrigger;
                const delay = parseInt(popup.dataset.popupDelay) || 0;
                const duration = parseInt(popup.dataset.popupDuration) || 24;

                // Skip localStorage check for click-triggered popups
                if (trigger !== 'click') {
                    // Check if popup was recently dismissed (only for automatic triggers)
                    if (this.isPopupDismissed(popupId, duration)) {
                        return;
                    }
                }

                // Get or create modal instance (reuse for click triggers)
                const modalInstance = this.getModalInstance(popup);

                // Ensure backdrop is properly removed on close
                popup.addEventListener('hidden.bs.modal', () => {
                    // Remove any lingering backdrops
                    const backdrops = document.querySelectorAll('.modal-backdrop');
                    backdrops.forEach(backdrop => backdrop.remove());

                    // Remove modal-open class from body
                    document.body.classList.remove('modal-open');
                    document.body.style.removeProperty('overflow');
                    document.body.style.removeProperty('padding-right');

                    // Track dismissal for automatic triggers
                    if (trigger !== 'click') {
                        this.markPopupDismissed(popupId);
                    }
                });

                // Handle trigger
                if (trigger === 'page_load') {
                    setTimeout(() => {
                        this.showPopup(modalInstance, popup);
                    }, delay * 1000);
                } else if (trigger === 'click') {
                    // For click trigger, popup appears every time button is clicked
                    this.setupClickTrigger(popupId, popup, delay);
                }

                // Handle scroll trigger (optional enhancement)
                if (trigger === 'scroll') {
                    this.setupScrollTrigger(modalInstance, popup, delay);
                }

                // Handle exit intent (optional enhancement)
                if (trigger === 'exit_intent') {
                    this.setupExitIntent(modalInstance, popup);
                }
            });
        }

        getModalInstance(popup) {
            const popupId = popup.dataset.popupId;

            // Check if instance already exists
            if (this.modalInstances[popupId]) {
                return this.modalInstances[popupId];
            }

            // Create new instance
            const instance = new bootstrap.Modal(popup, {
                backdrop: popup.dataset.bsBackdrop === 'static' ? 'static' : true,
                keyboard: popup.dataset.bsKeyboard === 'true'
            });

            this.modalInstances[popupId] = instance;
            return instance;
        }

        showPopup(modalInstance, popup) {
            modalInstance.show();

            // Track popup view (can be extended to send to analytics)
            const popupId = popup.dataset.popupId;
            this.trackPopupView(popupId);
        }

        setupClickTrigger(popupId, popup, delay) {
            const triggers = document.querySelectorAll(`[data-popup-trigger="${popupId}"]`);
            const modalInstance = this.getModalInstance(popup);

            triggers.forEach(trigger => {
                trigger.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    if (delay > 0) {
                        setTimeout(() => {
                            this.showPopup(modalInstance, popup);
                        }, delay * 1000);
                    } else {
                        this.showPopup(modalInstance, popup);
                    }
                });
            });
        }

        setupScrollTrigger(modalInstance, popup, delay) {
            let triggered = false;
            const scrollPercentage = 50; // Show after 50% scroll

            const handleScroll = () => {
                if (triggered) return;

                const scrolled = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;

                if (scrolled >= scrollPercentage) {
                    triggered = true;

                    setTimeout(() => {
                        this.showPopup(modalInstance, popup);
                    }, delay * 1000);

                    window.removeEventListener('scroll', handleScroll);
                }
            };

            window.addEventListener('scroll', handleScroll);
        }

        setupExitIntent(modalInstance, popup) {
            let triggered = false;

            document.addEventListener('mouseleave', (e) => {
                if (triggered) return;

                if (e.clientY <= 0) {
                    triggered = true;
                    this.showPopup(modalInstance, popup);
                }
            });
        }

        isPopupDismissed(popupId, duration) {
            const storageKey = `dt_popup_dismissed_${popupId}`;
            const dismissedTime = localStorage.getItem(storageKey);

            if (!dismissedTime) {
                return false;
            }

            const now = new Date().getTime();
            const dismissedTimestamp = parseInt(dismissedTime);
            const durationMs = duration * 60 * 60 * 1000; // Convert hours to milliseconds

            // Check if enough time has passed
            if (now - dismissedTimestamp < durationMs) {
                return true;
            }

            // Clean up old storage
            localStorage.removeItem(storageKey);
            return false;
        }

        markPopupDismissed(popupId) {
            const storageKey = `dt_popup_dismissed_${popupId}`;
            const now = new Date().getTime();
            localStorage.setItem(storageKey, now.toString());
        }

        trackPopupView(popupId) {
            // Can be extended to send analytics data
            //console.log(`Popup ${popupId} viewed`);

            // Example: Send to Google Analytics
            if (typeof gtag !== 'undefined') {
                gtag('event', 'popup_view', {
                    'popup_id': popupId
                });
            }
        }
    }

    // Initialize popup handler
    new DTPopup();

})(jQuery);
